import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e764249"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toast-icon" }, null, -1))
const _hoisted_4 = { class: "toast-message" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", {
    class: "toast-container d-print-none",
    id: _ctx.identifier
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastList, (toast) => {
      return (_openBlock(), _createElementBlock("div", {
        key: toast,
        class: _normalizeClass('toast-' + toast.type + ' toast ' + _ctx.showStatus(toast.id)),
        id: 'toast-notification-' + toast.id,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(toast.header), 1),
          (toast.showCloseButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "toast-close",
                onClick: ($event: any) => (_ctx.onClose(toast.id)),
                "aria-label": "Close toast notification"
              }, "Close toast notification", 8, _hoisted_6))
            : _createCommentVNode("", true),
          (toast.renderAsHtml)
            ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, null, 512)), [
                [_directive_dompurify_html, toast.message]
              ])
            : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(toast.message), 1)),
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}